<div
  [proffeoSpinner]="companyDraftProjects() === undefined"
  proffeoSpinnerSize="lg"
  class="min-h-48 w-full"
>
  @if (companyDraftProjects()?.length === 0) {
    <div class="flex w-full items-center justify-center p-4">
      <p>{{ 'placeholders.no-results-found' | translate }}</p>
    </div>
  } @else if (companyDraftProjects(); as projects) {
    @for (project of projects; track project.id) {
      <proffeo-company-project-item
        (deleteProject)="openProjectTagDeleteConfirmationDialog($event)"
        (editProject)="openEditCompanyProjectDialog($event)"
        [project]="project"
        [isDraftProject]="true"
      ></proffeo-company-project-item>
    }
  }
</div>
